import * as jsYaml from 'js-yaml'
import type { ExternalServiceCredentials } from '../../types/velociraptor-settings'

type ParsedYaml = Record<string, unknown>

function runYamlParse(yamlText: string): ParsedYaml | null {
  try {
    const result = jsYaml.load(yamlText)
    if (typeof result !== 'object' || result === null) {
      return null
    }
    return result as ParsedYaml
  } catch {
    return null
  }
}

export function parseApiClientYaml(yamlText: string): ExternalServiceCredentials | null {
  const parsed = runYamlParse(yamlText)
  if (parsed === null) {
    return null
  }
  const caCertificate = parsed['ca_certificate']
  const clientCert = parsed['client_cert']
  const clientKey = parsed['client_private_key']
  const apiConnectionString = parsed['api_connection_string']
  if (
    typeof caCertificate !== 'string' ||
    typeof clientCert !== 'string' ||
    typeof clientKey !== 'string' ||
    typeof apiConnectionString !== 'string'
  ) {
    return null
  }
  return { caCertificate, clientCert, clientKey, apiConnectionString }
}
